<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{ $t('logPageTitle') }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{today}}</v-toolbar-title>
        </v-toolbar>
        <v-flex class="flex">
          <v-data-table :items="filteredUsers" class="mt-10">
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th scope="col">
                    <v-select
                      :label="$t('date')"
                      :items="users"
                      v-model="filters.createDate"
                      multiple
                      clearable
                      item-text="createDate"
                      item-value="createDate"
                    ></v-select>
                  </th>
                  <th scope="col">{{ $t('logIdCol') }}</th>
                  <th scope="col">{{$t('username')}}</th>
                  <th scope="col">{{ $t('ipAddressCol') }}</th>
                  <th scope="col">{{$t('description')}}</th>
                  <th scope="col">{{ $t('logTypeCol') }}</th>
                  <th scope="col">{{ $t('methodNameCol') }}</th>
                  <th scope="col">{{ $t('exceptionCol') }}</th>
                  <th scope="col">{{ $t('logTraceCol') }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{convertUTCDateToLocalDate(item.createDate) }}</td>
                <td>{{ item.logId }}</td>
                <td>{{ item.userName }}</td>
                <td>{{ item.ip }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.logType }}</td>
                <td>{{ item.methodName }}</td>
                <td>{{ item.exception }}</td>
                <td>{{ item.logTrace }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <br />
        <br />
        <br />
      </v-card>
      <v-overlay  :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            {{ $t('loadingPleaseWait') }}
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import LogTrace from "@/api/function.js";
export default {
  mixins: [LogTrace],
  name: "Log",
  data: () => ({
    filters: {
      createDate: []
    },
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    header: [
      {
        text: "Date",
        value: "date"
      },
      { text: "Log ID", value: "menu" },
      { text: "User Name", value: "user" },
      { text: "IP Address", value: "user" },
      { text: "Description", value: "user" },
      { text: "Log Type", value: "user" },
      { text: "Method Name", value: "user" },
      { text: "Exception", value: "user" },
      { text: "Log Trace", value: "edit" }
    ],
    today: null,
    items: ["foo", "bar", "fizz", "buzz"],
    values: ["foo", "bar"],
    value: null,
    users: [],
    images: {
      edit: require("@/assets/edit1.png")
    }
  }),
  computed: {
    filteredUsers() {
      return this.users.filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    }
  },
  methods: {
    convertUTCDateToLocalDate(date) {
      date = new Date(date);

      let timezone = date.getTimezoneOffset() * 60000;
      let newDate = new Date(date.getTime() - timezone);
      let output =
        newDate.getDate() +
        "/" +
        newDate.getMonth() +
        "/" +
        newDate.getFullYear() +
        "   " +
        newDate.getHours() +
        ":" +
        newDate.getMinutes();

      return output;
    },

    GetLog() {
      try {
        this.dialog = true;
        axios
          .post(`${this.url}Log/GetLogALL`)
          .then((response) => {
            this.users = response.data.data;
            this.dialog = false;
          })
          .catch((error) => {
            alert(error);
            this.dialog = false;
          });
      } catch (error) {
        this.LogTrace(error, "GetLog");
      }
    }
  },
  mounted() {
    this.GetDate();
    this.GetLog();
  }
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
.pagin {
  margin-top: 1.5rem;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>